import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=2a94d369"
import script from "./ConsentPage.vue?vue&type=script&lang=js"
export * from "./ConsentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports